import React from "react";
import {Create} from "react-admin";
import UGroupForm from "./edit/UGroupForm";
import CreateToolbar from "common/forms/CustomToolbar";

export default (props) => (
  <Create {...props}>
    <UGroupForm action='create' toolbar={<CreateToolbar redirect='edit'/>}/>
  </Create>
);